/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_3_QInputs */

const en_vc_onl_faq_3_q = /** @type {(inputs: Vc_Onl_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app shows a blank or black screen. What can I do?`)
};

const zh_vc_onl_faq_3_q = /** @type {(inputs: Vc_Onl_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开后是白屏或黑屏，怎么办？`)
};

/**
* | output |
* | --- |
* | "The app shows a blank or black screen. What can I do?" |
*
* @param {Vc_Onl_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_3_q = /** @type {((inputs?: Vc_Onl_Faq_3_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_3_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_3_q(inputs)
	return zh_vc_onl_faq_3_q(inputs)
});
export { vc_onl_faq_3_q as "vc.onl.faq.3.q" }